import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { ITableModel } from "../table/model/tableModel";
import { appService } from "../../../_services/app.service";
import { ToastrService } from "ngx-toastr";
import { Helpers } from "../../../helpers";
import { DecryptPipe } from "../../../auth/_services/encrypt-decrypt.pipe";
import { CookieService } from "ngx-cookie-service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { OrdersService } from "../../services/orders/orders.service";
import { DatePipe } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
import { ShipnowPopupComponent } from '../shipnow-popup/shipnow-popup.component';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { Observable } from 'rxjs';
declare var google: any;
import * as L from 'leaflet';
import 'leaflet-routing-machine';
declare var $: any;

@Component({
  selector: "app-bidding",
  templateUrl: "./bidding.component.html",
  styleUrls: ["./bidding.component.scss"],
})
export class BiddingComponent implements OnInit, OnDestroy {
  tableDetails: ITableModel;
  totalOrderCount: number = 0;
  noOfPages: number = 15;
  @Input() Orderid: any;
  @Input() IndentNo: any;
  @Input() BidClosed: boolean;
  @Input() packageList: any;
  UserId: any;
  userId: any;
  selectedbiddata: any[] = [];
  @Output() bidSelected: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild("AssignVehicle") AssignVehicle: TemplateRef<any>;

  modalRef: any;
  TransationType: any;
  Id: any;
  bookingData: any = {};
  TransportServiceList: any;
  courierListIds: any = [];
  SelectedFtlListData: any = [];
  isBidClosed: boolean = false;
  CompanyId: any;
  ManualvehiclePlanning: any = {};
  static that: BiddingComponent;
  CourierList: any = [];
  CourierPackages: any = [];
  CourierDimentions: any = [];
  CourierAdditionalPack: any = [];
  OrdersPackage: any = [];
  TransportNames: any = [];
  OrderData: any = {};
  modalTitle = "";
  modalMessage = "Are you sure you want to Ship Now?";
  Balance: number = 0
  private refreshBid: any;
  filterObj: any = {
    Status: "All",
  };
  isMobileView: boolean;
  @ViewChild('BidDetailsModal') BidDetailsModal: TemplateRef<any>;

  BidDetailData: any = {};
  OrderListDetails: any = [];
  VehicleDetails: any = [];
  PackageListDetails: any = [];
  BiddingDetails: any = [];
  biddingduration: any;
  isSubmitDisable: boolean;
  biddingendsin: any;
  interval: any;

  PackageDetails: ITableModel = {
    data: [],
    columnDetails: [
      { columnName: "Product Name", dataFieldName: "ProductName" },
      { columnName: "Qty", dataFieldName: "Qty" },
      { columnName: "Weight", dataFieldName: "weight" },
      { columnName: "CBM", dataFieldName: "CBM" },
      { columnName: "Amount", dataFieldName: "InvoiceAmount" },
    ],
    footerData: [
      { ProductName: "Total", Qty: 0, weight: 0, CBM: 0, InvoiceAmount: 0 },
    ],
    actionList: [],
    isColumnNameShow: true,
    isShowFooterData: true,
  };

  Orderdetail: any = {
    cardName: "Indent No",
    NewHeaderData: true,
    id: "orderInfo",
    isShowOrderNo: true,
    // IndentNo:"OrderNo",
    // NewlistOfRow: [
    //   [
    //     {
    //       label: "",
    //       dataField1: "OrderNo",
    //     },
    //   ]
    // ],
    listOfRow: [
      [
        {
          label: "Pickup",
          dataField: "PickUpContactPerson",
          dataField1: "PickupAddress",
        },
        {
          label: "Delivery",
          dataField: "DeliveryContactPerson",
          dataField1: "DeliveryAddress",
        },
      ],
      [
        { label: "Pickup Date", dataField: "PickupDate" },
        { label: "Delivery Date", dataField: "DeliviryDate" },
      ],
    ],
    isColumnNameShow: true,
  };

  TransporterId: any;

  BidAmount: any = {
    lable: "",
    formControlName: "BidAmount",
    dataField: "BidAmount",
    isRequired: false,
    placeholder: "Enter your bid amount",
    type: "number",
  };
  Remark: any = {
    lable: "",
    formControlName: "Remark",
    dataField: "Remark",
    isRequired: false,
    placeholder: "Enter remark",
    type: "text",
  };

  AvailableDate: any = {
    lable: "",
    formControlName: "AvailableDate",
    dataField: "AvailableDate",
    isRequired: false,
    // added by priya - 28/01/25
    isTime: true,
    placeholder: "Select Date",
  };

  VehicleReqiredId: any
  VehicleTypeId
  selectedVehicles: {
    bidDetailId: any;
    VehicleReqiredId: any;
    AvailableDate: any;
    VehicleAmount: any;
    Remark: any;
    VehicleTypeId: any;
  }[] = [];

  totalBidAmount: number = 0;
  BidTransporter: any = {};

  TransporterDetails: any = {
    cardName: "Transporter Details",
    id: "orderInfo",
    listOfRow: [
      [
        {
          dataField: "Transporter",
          // dataField1: "TransportModeType",
          imgDataField: "LogoPath",
          valueType: "isNewTransporter",
          isNewRating: true,
          dataFieldRating: "StarRating",
        },
      ],
      [{ isNewHrLine: true }],
      [
        {
          phonedataField: "TransporterPhone",
          isNewIcon: true,
          NewlogoIcon: "../../../../assets/svg/Design/phone.svg",
          isNewPhone: true,
          color: "#3b67fb",
        },
      ],
      [
        {
          EmaildataField: "TransporterEmail",
          isNewIcon: true,
          NewlogoIcon: "../../../../assets/svg/Design/newemail.svg",
          isNewEmail: true,
          color: "#3b67fb",
        },
      ],
    ],
    isColumnNameShow: true,
  };


  TotalQty: any = 0;
  Totalweight: any = 0;
  TotalCBM: any = 0;
  TotalInvoiceAmount: any = 0;
  isBidDetailsModalOpen = false;
  IsAssignvehicleSaveDisable: any = false;
  ValidateTHCADvanceAmountFlag: boolean = false;
  ManualvehicleOrderList: any = [];
  ManualvehicleOrderDetail = [];
  isSTPBooking: any = false;
  ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag = false;
  CourierRate: any = [];
  NetTotal: any = 0;
  TaxApplicableFlag: boolean = false;
  headerCategories:any=[];
  @Input() TransportService: any; // Added by priya - 07/04/2026 - cn(PRIYA-APR26-002)

  searchFieldDetails: any = {
    placeholder: "Search",
    formControlName: "Search",
    type: "text",
    isSearchBox: true,
  };
  
  searchValue: string = '';
  @ViewChild("ContractedRateBreak") ContractedRateBreak: TemplateRef<any>;

  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private orderService: OrdersService,
    private router: Router,
    private dp: DatePipe,
    private translate: TranslateService,
    private mobileDetectionService: MobileDetectionService,
  ) {
    BiddingComponent.that = this;
  }

  ngOnInit() {
    
    this.BiddingList();
    this.GetTransporterListHired();
    this.UserId = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("UserId"))
    );
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.route.queryParamMap.subscribe((params) => {
      this.Id = params.get("id");
      this.TransationType = params.get("type");
      if (this.Id != null && this.Id != undefined && this.Id != "") {
        if (this.TransationType == 'FTL' || this.TransationType == 'ContainerMovement') { //added by BURHAN - || this.TransationType == 'ContainerMovement' - 14-May-2026
          this.initiateCourierList(this.Id);
        }
      }
    });
    this.GetTransportService();
    const rowDataString = localStorage.getItem("RowData");
    if (rowDataString) {
      this.SelectedFtlListData = JSON.parse(rowDataString);
    }
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.GetBidDetails();
    console.log('packageList', this.packageList)
    // this.GetNewOrdersDetailList();
    // this.refreshBid = setInterval(() => {
    //   this.GetTransporterListHired();
    // }, 30000);
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
    this.interval = setInterval(() => this.calculateTimeRemaining(), 1000);
  }


  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

  ngOnDestroy() {
    if (this.refreshBid) {
      clearInterval(this.refreshBid);
    }
  }

  reasonDetails: any = {
    cardName: "TRUCK'S DETAILS",
    id: "reasonDetails",
    listOfRow: [

      [{
        dataField: 'Name',
        // imgDataField: 'Logo',
        // divType: 'isUserDetails',
        isCheckBox: true
      },
      { isRating: true, dataFieldRating: 'starRating' }],
      [
        {
          dataField: "VehicleType",
          label: "Vehicle Type",
        },
        {
          dataField: "MinBidAmount",
          label: "Min. Bid Amount",
        },
        {
          dataField: "BidAmount",
          label: "Bid Amount",
        },
      ],

    ],
    footer: {
      actionBtn: true,
      actionList: [
        { label: "Via WhatsApp" },
        {
          label: "Via SMS",
          command: (event?: any) => console.log(event),
        },
        {
          label: "Via Mail",
          command: (event?: any) => console.log(event),
        },
        {
          label: "Set Minimum Bid Amount",
        },
        // {
        //   label: "Set Bid Amount",
        // },
      ],
    },
  };

  async BiddingList() {
    this.tableDetails = {
      data: [],
      columnDetails: [
        {
          columnName: "Transporter (Press Ctrl + F to search)",
          dataFieldName: "Name",
          dataFieldName2: "Phone",
          dataFieldName3: "Email",
          userIcon: "Logo",
          divType: "UserDetails",
          isContracted: true,
          isCheckBox: true,
        },
        {
          columnName: "Rating",
          dataFieldName: "starRating",
          divType: "newnetworkrating",
        },
        { columnName: "Request Sent", dataFieldName: "BidStatus" },
        {
          columnName: "Weight/Volume",
          dataFieldName: "TotalWeight",
          dataFieldName2: "TotalVolume",
          divType: "ftlCustomers",
        },
        { columnName: 'Vehicle Type', dataFieldName: 'VehicleType', },
        // { columnName: "Email", dataFieldName: "Email" },
        // { columnName: "Mobile", dataFieldName: "Phone" },
        { columnName: "Bid Amount", dataFieldName: "BidAmount",alignType: "right",divType: "BiddingRateBreakup", },
        { columnName: "Availability Date", dataFieldName: "AvailabilityDate" },
        { columnName: "Level", dataFieldName: "Level" },
        { columnName: "L1 Bid Amount", dataFieldName: "L1BidAmount" },
        { columnName: "Remark", dataFieldName: "Remark" },
        { columnName: "Actions", dataFieldName: "BidAmount", dataFieldName10: "isBooking", divType: "NewBiddingAction" },
      ],
      actionList: [
        { label: "Via WhatsApp" },
        {
          label: "Via SMS",
          command: (event?: any) => console.log(event),
        },
        {
          label: "Via Mail",
          command: (event?: any) => console.log(event),
        },
        // {
        //   label: "Set Minimum Bid Amount",
        // },
        // {
        //   label: "Set Bid Amount",
        // },
        {
          label: "Send Vehicle Request",
        },
      ],
      isColumnNameShow: true,
    };

     this.headerCategories = [
        {
          label: 'Send Bid Request',
          subOptions: [
            { icon: 'assets/svg/General/Mail.svg', label: 'Via Mail', value: 'Via Mail' },
            { icon: 'assets/svg/General/SMS.svg', label: 'Via SMS', value: 'Via SMS' },
            { icon: 'assets/svg/General/Whatsapp.svg', label: 'Via WhatsApp', value: 'Via WhatsApp' },
            { icon: 'assets/svg/General/ViaAll.svg', label: 'Via All', value: 'Via All' }
          ]
        },
        {
            label: 'Send Vehicle Request',
            subOptions: [
              { icon: 'assets/svg/General/Mail.svg', label: 'Via Mail', value: 'Via Mail' },
              { icon: 'assets/svg/General/SMS.svg', label: 'Via SMS', value: 'Via SMS' },
              { icon: 'assets/svg/General/Whatsapp.svg', label: 'Via WhatsApp', value: 'Via WhatsApp' },
              { icon: 'assets/svg/General/ViaAll.svg', label: 'Via All', value: 'Via All' }
            ]
        },
        {
          label: 'Award Shipment',  //added by fahim 02-02-2026 :)
        }
        // {
        //   label: 'Set Bid Amount',
        // }
      ];
  }

  onActionClick({ row, actionName }) {
    if (actionName.trim() == "Via Mail") {
      this.SaveTransportersBids(row, "Mail");
    } else if (actionName.trim() == "Set Bid Amount") {

      this.TransporterId = row.Id;
      let transporterList = []
      const transformVehicleTypes = (vehicleType, vehicleTypeId) => {
        const vehicleTypeArray = vehicleType.split(", "); // Split VehicleType string
        const vehicleTypeIdArray = vehicleTypeId.split(", "); // Split VehicleTypeId string

        // Map them into an array of objects
        return vehicleTypeArray.reduce((result, type, index) => {
          const [vehicle, quantity] = type.split(" X "); // Split into VehicleType and Quantity
          const qty = parseInt(quantity) || 1; // Default to 1 if Quantity is not present

          // Expand the vehicle type based on quantity
          for (let i = 0; i < qty; i++) {
            result.push({
              VehicleType: vehicle.trim(),
              VehicleTypeId: vehicleTypeIdArray[index].trim(), // Match VehicleTypeId
            });
          }
          return result;
        }, []);
      };

      transporterList = Array.isArray(row)
        ? row.reduce((acc, element) => {
          const vehicleData = transformVehicleTypes(element.VehicleType, element.VehicleTypeId);
          const expandedData = vehicleData.map((data) => ({
            ...element,
            IsEmailSms: 'self',
            TransporterId: element.Id,
            Transporter: element.Name,
            IndentId: this.Orderid,
            IndentNo: this.IndentNo,
            UserId: this.UserId,
            IsContracted: false,
            VehicleType: data.VehicleType,
            VehicleTypeId: data.VehicleTypeId,
          }));
          return acc.concat(expandedData);
        }, [])
        : transformVehicleTypes(row.VehicleType, row.VehicleTypeId).map((data) => ({
          ...row,
          IsEmailSms: 'self',
          TransporterId: row.Id,
          Transporter: row.Name,
          IndentId: this.Orderid,
          IndentNo: this.IndentNo,
          UserId: this.UserId,
          IsContracted: false,
          VehicleType: data.VehicleType,
          VehicleTypeId: data.VehicleTypeId,
        }));


      this._appService.Post("OrdersByVehicle", "SaveManualBidDetails", transporterList).subscribe((response) => {
        Helpers.setLoading(false);
        if (response[0].isDone) {
          this.fetchBidDetails(row.Id);
        } else {
          this.toastr.error("Bid Load failed !", "Error");
        }
      },
        (err) => {
          console.log(err);
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        });
      console.log('transporterlist', transporterList)
    } else if(actionName.trim() == 'Send Vehicle Request'){
       let transporterList = [];
        transporterList = Array.isArray(event) ? event.map((element) => ({
          BidAmount: 0,
          Email: element.row.Email,
          IndentId: this.Orderid,
          IndentNo: this.IndentNo,
          IsEmailSms: 'Mail',
          MinBidAmount: 0,
          Phone: element.row.Phone,
          Rating: element.row.Rating,
          Transporter: element.row.Name,
          TransporterId: element.row.Id,
          TransporterType: "FTL",
          UserId: this.UserId,
          IsContracted: false,
          VehicleType: element.row.NewVehicleType,
          VehicleTypeId: element.row.VehicleTypeId,
          TransporterBidDetailId: element.row.trnasporterBidDetailId
        })) :
          [{
            BidAmount: 0,
            Email: row.Email,
            IndentId: this.Orderid,
            IndentNo: this.IndentNo,
            IsEmailSms: 'Mail',
            MinBidAmount: 0,
            Phone: row.Phone,
            Rating: row.Rating,
            Transporter: row.Name,
            TransporterId: row.Id,
            TransporterType: "FTL",
            UserId: this.UserId,
            IsContracted: false,
            VehicleType: row.NewVehicleType,
            VehicleTypeId: row.VehicleTypeId,
            TransporterBidDetailId: row.trnasporterBidDetailId
          }];
        console.log("transporterList:", transporterList, transporterList[0].VehicleTypeId);
      // added by priya - 02/09/2025
      // if required vehicles count are fulfilled for order and pending vehicle is 0 then it will show warning
      let pendingCount = 0;
      this._appService.GetById("OrdersByVehicle", "GetNewOrdersDetailList", this.Id).subscribe((res) => {
        // pendingCount = res.Table[0].Pending;
        if (res && res.Table && res.Table.length > 0 && res.Table[0]) {
          pendingCount = res.Table[0].Pending ? res.Table[0].Pending : 0;
        }else{
          pendingCount=1;
        }
        if (pendingCount <= 0) {
          this.toastr.warning('Transporter is allocated for this shipment', 'Warning')
          return
        } else {
          this._appService.Post("OrdersByVehicle", "SendShipNowMail", transporterList).subscribe(
          (response) => {
              if (response) {
                  this.toastr.success("Request Sent Successfully !", "Success");
                } else {
                  this.toastr.error("Request sent failed !", "Error");
                }
            },
            (err) => {
              console.log(err);
              Helpers.setLoading(false);
              this.toastr.error(err._body.replace(/"/g, ""), "Error");
            }
          );
        }
      });  
    } else if(actionName.trim() == 'Award Shipment'){  //added by fahim 02-02-2026 :)
      console.log(`${row.Name} Won the aword`);
    }
  }

  fetchBidDetails(transporterId) {
    this._appService.GetByTwoId("OrdersByVehicle", "GetBiddingDetails", this.Orderid, transporterId).subscribe(
      (res) => {
        Helpers.setLoading(false);

        this.BidDetailData = res;
        this.OrderListDetails = res.Table[0];
        this.biddingduration = res.Table[0].BidDuration;
        this.VehicleDetails = res.Table1;
        this.PackageListDetails = res.Table2;
        this.BiddingDetails = res.Table3;

        this.PackageDetails.data = this.PackageListDetails;

        var totals = { Qty: 0, weight: 0, CBM: 0, InvoiceAmount: 0 };
        for (var i = 0; i < this.PackageListDetails.length; i++) {
          var item = this.PackageListDetails[i];
          totals.Qty += item.Qty || 0;
          totals.weight += item.weight || 0;
          totals.CBM += item.CBM || 0;
          totals.InvoiceAmount += item.InvoiceAmount || 0;
        }

        this.TotalQty = totals.Qty;
        this.Totalweight = totals.weight;
        this.TotalCBM = totals.CBM;
        this.TotalInvoiceAmount = totals.InvoiceAmount;

        this.PackageDetails.footerData[0] = {
          ProductName: "Total",
          Qty: totals.Qty,
          weight: totals.weight,
          CBM: totals.CBM,
          InvoiceAmount: totals.InvoiceAmount
        };

        this.isBidClosed = this.OrderListDetails.BidOpen === true;
        console.log(this.Orderid);
        console.log(this.TransporterId);

        this.isBidDetailsModalOpen = true;
        // this.modalRef = this.modalService.open(this.BidDetailsModal, { centered: true, size: "lg" });
      },
      (error) => {
        Helpers.setLoading(false);
        console.error("GetBiddingDetails error", error);
      }
    );
  }

  closeModal() {
    this.modalRef.close();
  }

  // added by priya - 20/01/25
  // saves bid in table and sends the mail to transporter for bidding
  SaveTransportersBids(row, biddingRequestType) {

    if (!row || (Array.isArray(row) && row.length === 0)) {
        this.toastr.warning("Please Select Transporter", "Error");
        return;
    }

    if (this.packageList && this.packageList.length > 0) {
      if (this.packageList[0].Pending == 0) {
        this.toastr.error("booking has already been shipped for this order.", "Error");
        return;
      }
    }
    Helpers.setLoading(true);
    let transporterList = []
    const transformVehicleTypes = (vehicleType, vehicleTypeId) => {
      if (!vehicleType || !vehicleTypeId) {
        return [{
          VehicleType: null,
          VehicleTypeId: null
        }];
      }

      const vehicleTypeArray = vehicleType.split(", "); // Split VehicleType string
      const vehicleTypeIdArray = vehicleTypeId.split(", "); // Split VehicleTypeId string

      // Map them into an array of objects
      return vehicleTypeArray.reduce((result, type, index) => {
        const [vehicle, quantity] = type.split(" X "); // Split into VehicleType and Quantity
        const qty = parseInt(quantity) || 1; // Default to 1 if Quantity is not present

        // Expand the vehicle type based on quantity
        for (let i = 0; i < qty; i++) {
          result.push({
            VehicleType: vehicle.trim(),
            VehicleTypeId: vehicleTypeIdArray[index].trim(), // Match VehicleTypeId
          });
        }
        return result;
      }, []);
    };

    transporterList = Array.isArray(row)
      ? row.reduce((acc, element) => {
        const vehicleData = transformVehicleTypes(element.VehicleType, element.VehicleTypeId);
        const expandedData = vehicleData.map((data) => ({
          ...element,
          IsEmailSms: biddingRequestType,
          TransporterId: element.Id,
          Transporter: element.Name,
          IndentId: this.Orderid,
          IndentNo: this.IndentNo,
          UserId: this.UserId,
          IsContracted: false,
          VehicleType: data.VehicleType,
          VehicleTypeId: data.VehicleTypeId,
        }));
        return acc.concat(expandedData);
      }, [])
      : transformVehicleTypes(row.VehicleType, row.VehicleTypeId).map((data) => ({
        ...row,
        IsEmailSms: biddingRequestType,
        TransporterId: row.Id,
        Transporter: row.Name,
        IndentId: this.Orderid,
        IndentNo: this.IndentNo,
        UserId: this.UserId,
        IsContracted: false,
        VehicleType: data.VehicleType,
        VehicleTypeId: data.VehicleTypeId,
      }));

      console.log('transporterList',transporterList);
    this._appService.Post("OrdersByVehicle", "SaveNewTransportersBids", transporterList).subscribe((response) => {
      Helpers.setLoading(false);
      if (response[0].isDone) {
        this.toastr.success("Bid Sent Successfully !", "Success");
        const uniqueTransporters = transporterList.filter(
          (item, index, self) =>
            index === self.findIndex(
              t =>
                t.IndentId === item.IndentId &&
                t.TransporterId === item.TransporterId &&
                t.VehicleTypeId === item.VehicleTypeId
            )
        );

        uniqueTransporters.forEach(t => {
          this.GetBiddingChargeList(
            t.IndentId,
            t.TransporterId,
            t.VehicleTypeId   // pass if needed
          );
        });


        // transporterList.forEach(t => {
        //   this.GetBiddingChargeList(t.IndentId, t.TransporterId);
        // });

        transporterList = []
        this.selectedbiddata = []
        this.GetTransporterListHired();
      } else {
        this.toastr.error("Bid sent failed !", "Error");
      }
    },
      (err) => {
        console.log(err);
        Helpers.setLoading(false);
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      });
  }

  SendVehicleRequest(event, RequestType) {
    console.log('mail event', event)
    const eventArray = Array.isArray(event) ? event : [event];
    
    if (eventArray.length === 0) {
      this.toastr.warning("Please Select Transporter", "Error");
      return;
    }

    Helpers.setLoading(true);
    const transporterList = eventArray.map(element => {
      const row = element.row || element;
      return {
        BidAmount: 0,
        Email: row.Email,
        IndentId: this.Orderid,
        IndentNo: this.IndentNo,
        IsEmailSms: RequestType,
        MinBidAmount: 0,
        Phone: row.Phone,
        Rating: row.Rating,
        Transporter: row.Name,
        TransporterId: row.Id,
        TransporterType: "FTL",
        UserId: this.UserId,
        IsContracted: false,
        VehicleType: row.NewVehicleType,
        VehicleTypeId: row.VehicleTypeId,
        TransporterBidDetailId: row.trnasporterBidDetailId
      };
    });

    console.log("transporterList:", transporterList);
    let pendingCount = 0;
    this._appService.GetById("OrdersByVehicle", "GetNewOrdersDetailList", this.Id).subscribe((res) => {
      // pendingCount = res.Table[0].Pending;
      if (res && res.Table && res.Table.length > 0 && res.Table[0]) {
        pendingCount = res.Table[0].Pending ? res.Table[0].Pending : 0;
      }else{
        pendingCount=1;
      }
      if (pendingCount <= 0) {
        this.toastr.warning('Transporter is allocated for this shipment', 'Warning')
        return
      } else {
        this._appService.Post("OrdersByVehicle", "SendShipNowMail", transporterList)
        .subscribe(
          (response) => {
            Helpers.setLoading(false);
            if (response) {
              this.toastr.success("Request Sent Successfully !", "Success");
              this.selectedbiddata = [];
              this.GetTransporterListHired();
            } else {
              this.toastr.error("Request sent failed !", "Error");
            }
          },
          (err) => {
            console.log(err);
            Helpers.setLoading(false);
            this.toastr.error(err._body.replace(/"/g, ""), "Error");
          }
        );
      }
    });
  }

  GetTransporterListHired(pageNo: number = 0, perPage: any = this.noOfPages, filterObject: any = this.filterObj) {
    Helpers.setLoading(true);
    var obj: any = {};
    obj.OrderId = this.Orderid;
    obj.Start = pageNo * perPage;
    obj.Length = perPage;
    obj.TransporterId = filterObject.HiredTransporter;
    obj.VehicleType = filterObject.VehicleType;
    obj.searchValue = this.searchValue || null;

    this._appService
      .Post("OrdersByVehicle", "NewGetTranspoterList", obj)
      .subscribe(
        (response) => {
          const data = Array.isArray(response) ? response : [];
          this.tableDetails.data = response;
          this.totalOrderCount = data.length > 0 ? data[0].Count : 0;
          this.assignTableFields(pageNo, perPage, response);
          Helpers.setLoading(false);
          this.tableDetails.data = data.map((item) => {
            let isSelected = false;

            if (this.selectedbiddata && this.selectedbiddata.length > 0) {
              for (let i = 0; i < this.selectedbiddata.length; i++) {
                let sel = this.selectedbiddata[i];

                let selVehicle = (sel.VehicleTypeId === null || sel.VehicleTypeId === undefined || sel.VehicleTypeId === '') ? '' : sel.VehicleTypeId;
                let itemVehicle = (item.VehicleTypeId === null || item.VehicleTypeId === undefined || item.VehicleTypeId === '') ? '' : item.VehicleTypeId;

                if (selVehicle !== '' && itemVehicle !== '') {
                  if (sel.Id === item.Id && selVehicle === itemVehicle) {
                    isSelected = true;
                    break;
                  }
                } 
                else {
                  if (sel.Id === item.Id) {
                    isSelected = true;
                    break;
                  }
                }
              }
            }

            item.isSelected = isSelected;
            return item;
          });
          console.log('selectedbiddata inside BiddingComponent',this.selectedbiddata);
          console.log('this.tableDetails.data BiddingComponent',this.tableDetails.data);
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  onPageChange(pageNo: number) {
    const storedPerPage = localStorage.getItem('perPage') || this.noOfPages;
    this.GetTransporterListHired(pageNo - 1, storedPerPage);
  }

  onPageNumberChange(noOfPages: any) {
    localStorage.setItem('perPage', noOfPages);
    this.GetTransporterListHired(0, noOfPages);
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails,
      paginationDetails: {
        totalItems: this.totalOrderCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1,
      },
      data: data,
    };
  }

  selectedRow(event) {
    console.log('event', event)
    if (!Array.isArray(this.selectedbiddata)) {
      this.selectedbiddata = [];
    }
    if (event.row.isSelected) {
      // const exists = this.selectedbiddata.some(
      //   (item) => item.Id === event.row.Id
      // );
      // if (!exists) {
      this.selectedbiddata.push({
        ...event.row,
        TransporterId: event.row.Id,
        Transporter: event.row.Name,
        IndentId: this.Orderid,
        IndentNo: this.IndentNo,
        UserId: this.UserId,
      });
      // this.selectedbiddata.push(event.row);
      // }
    } else {
      this.selectedbiddata = this.selectedbiddata.filter(
        (item) => item.Id !== event.row.Id
      );
    }
    this.bidSelected.emit(this.selectedbiddata);
    console.log(this.selectedbiddata);
  }

  GetTransportService() {
    this.orderService.GetTransportServiceList().then((res) => {
      this.TransportServiceList = res;
    })
      .catch((error) => {
        console.log(error);
      });
  }

  ShipActionBtn(event){
    // added by priya - 02/09/2025
    // if required vehicles count are fulfilled for order and pending vehicle is 0 then it will show warning
    let pendingCount = 0;
    this._appService.GetById("OrdersByVehicle", "GetNewOrdersDetailList", this.Id).subscribe((res) => {
      // pendingCount = res.Table[0].Pending;
      if (res && res.Table && res.Table.length > 0 && res.Table[0]) {
        pendingCount = res.Table[0].Pending ? res.Table[0].Pending : 0;
      }else{
        pendingCount=1;
      }

      if (pendingCount <= 0) {
        this.toastr.warning('Transporter is allocated for this shipment', 'Warning')
        return
      } else {
      var difference = 0;
      if (this.TransationType == "FTL") {
        // this.bookingData.VehicleNo = event.row.RegistrationNo;
        this.bookingData.Transporter = event.row.Id
        this.bookingData.TransporterName = event.row.Name;
        // this.bookingData.Driver = event.row.DriverName;
        // this.bookingData.DriverName = event.row.Driver;
        // this.bookingData.DriverCode = event.row.DriverCode;
        this.bookingData.DriverMobileNo = event.row.MobileNo;
        // commented and added by priya - 07/04/2026 - cn(PRIYA-APR26-002)
        // this.bookingData.TransportService = this.TransportServiceList.filter(
        //   (x) => x.Label === "FTL"
        // )[0].Id;
        let selectedService = this.TransportServiceList.find(
          (x: any) => x.Label === this.TransportService.TransportName
        );
        if (!selectedService) {
          selectedService = this.TransportServiceList.find((x: any) => x.Label === "FTL");
        }
        this.bookingData.TransportService = selectedService ? selectedService.Id : null;
        // end by priya
        // this.bookingData.VehiclePlacementDate = this.dp.transform(new Date(), "dd-MMM-yyyy");
        this.bookingData.VehiclePlacementDate = this.dp.transform(new Date(), "dd-MMM-yyyy");
        const travelTime = event.row.VehicleTravelTime || 0;
        this.bookingData.VehicleTravelTime = travelTime;
        this.bookingData.VehicleDistance = event.row.VehicleDistance || 0;
        this.bookingData.OrderPickupDate = event.row.OrderPickupDate;
        // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-007)
        // const orderDate = new Date(event.row.OrderDeliveryDate);
        // this.bookingData.OrderDeliveryDate = orderDate;
        // const placementDate = new Date();
        // let estimatedDate: Date;
        // let leadTime = 0;
        // if (travelTime) {
        //   const dayMatch = travelTime.match(/(\d+)\s*day/);
        //   const hourMatch = travelTime.match(/(\d+)\s*hour/);
        //   const minMatch = travelTime.match(/(\d+)\s*min/);

        //   const days = dayMatch ? parseInt(dayMatch[1], 10) : 0;
        //   const hours = hourMatch ? parseInt(hourMatch[1], 10) : 0;
        //   const minutes = minMatch ? parseInt(minMatch[1], 10) : 0;

        //   leadTime = days;
        //   estimatedDate = new Date(placementDate);

        //   estimatedDate.setDate(estimatedDate.getDate() + days);
        //   estimatedDate.setHours(estimatedDate.getHours() + hours);
        //   estimatedDate.setMinutes(estimatedDate.getMinutes() + minutes);
        // } else {
        //   estimatedDate = new Date();
        //   leadTime = 0;
        // }

        // this.bookingData.EstimatedDeliveryDate = this.dp.transform(estimatedDate, "dd-MMM-yyyy HH:mm:ss");
        // this.bookingData.LeadTime = leadTime;
        // End by priya
        this.bookingData.EstimatedDeliveryDate = this.dp.transform(new Date(), "dd-MMM-yyyy");
        this.bookingData.LeadTime = 0;
        this.bookingData.Advance = 0;
        this.bookingData.DriverLicenseNo = event.row.DriverLicenseNo;
        this.bookingData.DriverDOB = event.row.DriverDOB ? this.dp.transform(new Date(event.row.DriverDOB), "dd-MMM-yyyy") : null;
        this.bookingData.VehicleType = event.row.VehicleTypeId.toLowerCase();
        this.bookingData.FromBidding = true;
        this.bookingData.BidAmount = event.row.BidAmount;
        console.log('event', this.bookingData)
      } else if (this.TransationType == 'ContainerMovement') {
        // Added and commented by priya - 07/04/2026 - cn(PRIYA-APR26-002)
        this.bookingData.VehicleType = event.row.VehicleTypeId;
        this.bookingData.VehicleNo = event.row.RegistrationNo;
        this.bookingData.Transporter = event.row.Id;
        this.bookingData.TransporterName = event.row.Name;
        this.bookingData.Driver = event.row.DriverName;
        this.bookingData.DriverName = event.row.Driver;
        this.bookingData.DriverCode = event.row.DriverCode;
        this.bookingData.DriverMobileNo = event.row.MobileNo;
        let selectedService = this.TransportServiceList.find(
          (x: any) => x.Label === this.TransportService.TransportName
        );
        this.bookingData.TransportService = selectedService ? selectedService.Id : null;
        this.bookingData.VehiclePlacementDate = this.dp.transform(new Date(), "dd-MMM-yyyy");
        this.bookingData.EstimatedDeliveryDate = this.dp.transform(new Date(), "dd-MMM-yyyy");
        this.bookingData.LeadTime = 0;
        this.bookingData.Advance = 0;
        this.bookingData.OrderPickupDate = event.row.OrderPickupDate;
        // end by priya
      } else if (this.TransationType == 'Air') {
        this.OnClickShipNow(event.row.ShortName, event.row.TransporterId, event.row.Transporter, event.row.LeadTime, event.row.service_code, event.row.Rate);
      } else {
        if (difference < 0) {
          this.toastr.info("Please Recharge to Confirm Order", "Info");
        } else {
          this.CreateConsignmentCountry(event.row.id, event.row.LeadTime);
        }
      }
        this.modalRef = this.modalService.open(this.AssignVehicle, { windowClass: 'assign-vehicle-modal', size: "lg", centered: false});
      }
    });
  }

  
  // creates booking and sends the mail to transporter for ship now
  // ShipActionBtn(event) {
  //   
  //   if (this.packageList[0].Pending == 0) {
  //     this.toastr.error("No pending bookings available !", "Error");
  //     return;
  //   }
  //   this.getWalletCount();
  //   const dialogRef = this.modalService.open(ShipnowPopupComponent, {
  //     centered: true,
  //   });
  //   dialogRef.componentInstance.details = {
  //     message: this.modalTitle,
  //     title: this.modalMessage,
  //   };
  //   if (this.TransationType == 'FTL') {
  //     dialogRef.componentInstance.IsRateValid = true;
  //   }
  //   dialogRef.componentInstance.close.subscribe((res: any) => {
  //     Helpers.setLoading(false);
  //     if (res) {
  //       //this.toastr.success("Mail Sent Successfully");
  //       let transporterList = [];
  //       transporterList = Array.isArray(event) ? event.map((element) => ({
  //         BidAmount: 0,
  //         Email: element.row.Email,
  //         IndentId: this.Orderid,
  //         IndentNo: this.IndentNo,
  //         IsEmailSms: 'Mail',
  //         MinBidAmount: 0,
  //         Phone: element.row.Phone,
  //         Rating: element.row.Rating,
  //         Transporter: element.row.Name,
  //         TransporterId: element.row.Id,
  //         TransporterType: "FTL",
  //         UserId: this.UserId,
  //         IsContracted: false,
  //         VehicleType: element.row.VehicleType,
  //         VehicleTypeId: element.row.VehicleTypeId,
  //         TransporterBidDetailId: element.row.trnasporterBidDetailId
  //       })) :
  //         [{
  //           BidAmount: 0,
  //           Email: event.row.Email,
  //           IndentId: this.Orderid,
  //           IndentNo: this.IndentNo,
  //           IsEmailSms: 'Mail',
  //           MinBidAmount: 0,
  //           Phone: event.row.Phone,
  //           Rating: event.row.Rating,
  //           Transporter: event.row.Name,
  //           TransporterId: event.row.Id,
  //           TransporterType: "FTL",
  //           UserId: this.UserId,
  //           IsContracted: false,
  //           VehicleType: event.row.VehicleType,
  //           VehicleTypeId: event.row.VehicleTypeId,
  //           TransporterBidDetailId: event.row.trnasporterBidDetailId
  //         }];
  //       console.log("transporterList:", transporterList, transporterList[0].VehicleTypeId);
  //       this._appService.GetBySixId("OrdersByVehicle", "CreareBookingFromOrder", this.Orderid, this.CompanyId, this.UserId, true, transporterList[0].VehicleTypeId, 1).subscribe((response) => {
  //         Helpers.setLoading(false);
  //         if (response == 100) {
  //           this.toastr.error("Booking is already created !", "error");
  //         } else {
  //           this.toastr.success("Booking Created Successfully !", "Success");
  //           this._appService.Post("OrdersByVehicle", "SendShipNowMail", transporterList).subscribe((response) => {
  //             if (response) {
  //               this.toastr.success("Request Sent Successfully !", "Success");
  //             } else {
  //               this.toastr.error("Request sent failed !", "Error");
  //             }
  //           },
  //             (err) => {
  //               console.log(err);
  //               Helpers.setLoading(false);
  //               this.toastr.error(err._body.replace(/"/g, ""), "Error");
  //             });
  //         }
  //       },
  //         (err) => {
  //           console.log(err);
  //           Helpers.setLoading(false);
  //           this.toastr.error(err._body.replace(/"/g, ""), "Error");
  //         });
  //     }
  //     dialogRef.close();
  //   });
  // }

  getWalletCount() {
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.UserId = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("UserId"))
    );
    this._appService.GetByTwoParam("OrdersByVehicle", "GetWalletCount", this.CompanyId, this.UserId).subscribe(
      (response) => {
        if (response.length > 0) {
          this.Balance = response[0].Balance;
        }
      },
      (err) => {
        console.log(err);
      });
  }

  // CreateBooking(){
  //   this._appService.GetByFourId("OrdersByVehicle", "CreareBookingFromOrder", this.Orderid, this.CompanyId, this.UserId, true).subscribe((response) => {
  //     Helpers.setLoading(false);
  //     if (response == 100) {
  //       this.toastr.error("Booking is already created !", "error");
  //     } else {
  //       this.toastr.success("Booking Created Successfully !", "Success");
  //     }
  //   },
  //   (err) => {
  //     console.log(err);
  //     Helpers.setLoading(false);
  //     this.toastr.error(err._body.replace(/"/g, ""), "Error");
  //   });
  // }

  async OnClickShipNow(ShortName, TransporterId, TransporterName, LeadTime, service_code, TotalRate) {
    // const hasComma = this.courierListIds.includes(",");
    // 
    // var obj: any;
    // if (hasComma == false) {
    //   obj = this.courierListIds;
    //   this.courierListIds = [];
    //   this.courierListIds.push(obj);
    // }
    for (let a = 0; a < this.courierListIds.length; a++) {
      await new Promise(async (resolve1, reject1) => {
        this._appService.GetById("OrdersByVehicle", "oc_GetCourierDataByIdConsignment", BiddingComponent.that.courierListIds[a]).subscribe(
          (response) => {
            var obj: any = {};
            obj.OrderDetails = response.Table[0];
            obj.ProductDetails = response.Table1;
            obj.ProductDimentions = response.Table2;
            obj.InvoiceDetails = response.Table3;
            obj.AdditionalServices = response.Table4;
            obj.OrdersPackage = response.Table5;

            var ConsignmentList: any = [];
            ConsignmentList.push(obj);
            BiddingComponent.that.CreateConsignment(
              obj,
              ShortName,
              BiddingComponent.that.courierListIds[a],
              TransporterId,
              TransporterName,
              LeadTime,
              service_code,
              TotalRate
            );
            resolve1("OK");
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching data !",
              "error"
            );
            resolve1("OK");
          });
      });
    }
  }

  CreateConsignmentCountry(TransporterId, LeadTime) {
    Helpers.setLoading(true);
    this._appService.GetByEightId("OrdersByVehicle", "oc_ConfirmCourierData_generateInvoiceOrderWiseV2", this.Id, this.userId, TransporterId, LeadTime, '', '', '', 0).subscribe(
      (response) => {
        if (response[0].isDone == "OK") {
          this.toastr.success("Order Confirm successfully !", "Success");
          Helpers.setLoading(false);
          this.router.navigateByUrl("/NewBookingList");
        } else {
          this.toastr.error(
            "Error Occurred While ConFirm Booking !",
            "Error"
          );
          Helpers.setLoading(false);
        }
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      });
  }

  async CreateConsignment(
    a: any,
    TransporterShortName: any,
    OrderId: any,
    TransporterId: any,
    TransporterName: any,
    LeadTime: any,
    service_code: any,
    TotalRate: any
  ) {
    var data: any = {};

    data.consignment = {};
    data.consignment.consolidate = 'No'; //this.DiffLocations == true ? 'No' : 'Yes';
    data.consignment.shipper_company_code = a.OrderDetails.PickupLocationCode;
    data.consignment.consignment_number = '';
    data.consignment.is_draft = "No";
    data.consignment.from_challan_id = "";
    data.consignment.consignor_company_id = "";
    data.consignment.consignor_company_name = a.OrderDetails.ConsignorCompany;
    data.consignment.consignor_company_code = a.OrderDetails.ConsignorCode;
    data.consignment.consignor_facility_name = a.OrderDetails.PickupCity;
    data.consignment.consignor_facility_code = a.OrderDetails.PickupLocationCode;
    data.consignment.consignor_address_line1 = a.OrderDetails.ConsignerAddress;
    data.consignment.consignor_address_line2 = "";
    data.consignment.consignor_city = a.OrderDetails.ConsignerCity;
    data.consignment.consignor_state = a.OrderDetails.ConsignerState;
    data.consignment.consignor_pin = a.OrderDetails.ConsignerPincode;
    data.consignment.consignor_contact_name = a.OrderDetails.PickUpContactPerson;
    data.consignment.consignor_phone = a.OrderDetails.PickUpContactNumber;
    data.consignment.consignee_company_id = "";
    data.consignment.consignee_company_name = a.OrderDetails.ConsigneeName;
    data.consignment.consignee_company_code = a.OrderDetails.ConsigneeCode;
    data.consignment.consignee_facility_name = a.OrderDetails.DeliveryCity;
    data.consignment.consignee_facility_code = a.OrderDetails.DeliveryLocationCode;
    data.consignment.consignee_address_line1 = a.OrderDetails.ConsigneeAddress;
    data.consignment.consignee_address_line2 = "";
    data.consignment.consignee_city = a.OrderDetails.ConsigneeCity;
    data.consignment.consignee_state = a.OrderDetails.ConsigneeState;
    data.consignment.consignee_pin = a.OrderDetails.ConsigneePincode;
    data.consignment.consignee_contact_name = a.OrderDetails.DeliveryContactPerson;
    data.consignment.consignee_phone = a.OrderDetails.DeliveryContactNumber;
    data.consignment.reference_number_1 = a.OrderDetails.ReferenceNo;
    data.consignment.reference_number_2 = "";
    data.consignment.service_option = 'SURF XPRS'; //a.OrderDetails.TransportName;
    data.consignment.truck_category = "";
    data.consignment.service_provider_company_code = TransporterShortName;
    data.consignment.vehicle_number = "";
    data.consignment.driver_name = "";
    data.consignment.driver_mobile_number = "";
    data.consignment.volume = ""; //a.OrderDetails.Volume;
    data.consignment.volume_measure = "";
    data.consignment.ready_for_pickup_at = a.OrderDetails.PickupLocationCode;
    data.consignment.payment_mode = 'To Bill'; //a.OrderDetails.Freight;
    data.consignment.slot_date = "";
    data.consignment.slot_name = "";
    data.consignment.slot_company_code = "";
    data.consignment.weight = a.OrderDetails.Weight;
    data.consignment.billable_weight = a.OrderDetails.VolumetricWeight > a.OrderDetails.Weight == true ? a.OrderDetails.VolumetricWeight : a.OrderDetails.Weight;
    data.consignment.weight_measure = "Kgs";

    data.consignment.consignment_contents = {};
    data.consignment.consignment_contents.consignment_content = [];
    data.product_data = [];
    data.products = [];
    data.consignment_contents_common = {};
    data.consignment_contents_common.consignment_content_common = [];
    for (let k = 0; k < a.ProductDetails.length; k++) {
      var obj: any = {};

      obj.reference_number = a.OrderDetails.ReferenceNo; //ASK
      obj.delivery_number = null; //ASK
      obj.product_id = "";
      obj.product_name = 'OTHERS'; //a.ProductDetails[k].ProductName;
      obj.product_display_name = a.ProductDetails[k].ProductName;
      obj.units = a.ProductDetails[k].Qty;
      obj.unit_type = 'Units'; //a.ProductDetails[k].UnitName;
      obj.weight = a.ProductDetails[k].weight;
      obj.billable_weight = a.ProductDetails[k].VolumetricWeight > a.OrderDetails.Weight == true ? a.ProductDetails[k].VolumetricWeight : a.OrderDetails.Weight;
      obj.weight_measure = "Kgs";
      obj.length = a.ProductDetails[k].Length;
      obj.width = a.ProductDetails[k].Width;
      obj.height = a.ProductDetails[k].Height;
      obj.uom = 'inches'; //a.ProductDetails[k].UnitName;
      data.consignment.consignment_contents.consignment_content.push(obj);

      //************************************************************** */
      var obj2: any = {};
      obj2.hsnno = a.ProductDetails[k].HSNNo;
      obj2.product_name = a.ProductDetails[k].ProductName;

      var total = parseFloat(a.ProductDetails[k].Price) * parseFloat(a.ProductDetails[k].Qty);
      if (a.OrderDetails.ConsignerState == a.OrderDetails.ConsigneeState) {
        obj2.SGSTAmount = total * (9 / 100);
        obj2.CGSTAmount = total * (9 / 100);
        obj2.IGSTAmount = 0;
        obj2.GSTTaxRateCGSTN = 9;
        obj2.GSTTaxRateSGSTN = 9;
        obj2.GSTTAXRateIGSTN = 0;
      } else {
        obj2.SGSTAmount = 0;
        obj2.CGSTAmount = 0;
        obj2.IGSTAmount = total * (18 / 100);
        obj2.GSTTaxRateCGSTN = 0;
        obj2.GSTTaxRateSGSTN = 0;
        obj2.GSTTAXRateIGSTN = 18;
      }

      obj2.Discount = 0;
      obj2.GSTTaxTotal = (obj2.SGSTAmount + obj2.CGSTAmount + obj2.IGSTAmount);
      obj2.TaxableValue = total + obj2.GSTTaxTotal;
      data.product_data.push(obj2);

      //************************************************************** */
      var obj3: any = {};

      obj3.reference_number = a.OrderDetails.ReferenceNo; //ASK
      obj3.delivery_number = null; //ASK
      obj3.product_id = "";
      obj3.product_name = 'OTHERS'; //a.ProductDetails[k].ProductName;
      obj3.product_display_name = a.ProductDetails[k].ProductName;
      obj3.units = a.ProductDetails[k].Qty;
      obj3.unit_type = 'Units'; //a.ProductDetails[k].UnitName;
      obj3.weight = a.ProductDetails[k].ProductWeight;
      obj3.billable_weight = a.ProductDetails[k].VolumetricWeight > a.OrderDetails.Weight == true ? a.ProductDetails[k].VolumetricWeight : a.OrderDetails.Weight;
      obj3.weight_measure = "Kgs";
      obj3.length = a.ProductDetails[k].Length;
      obj3.width = a.ProductDetails[k].Width;
      obj3.height = a.ProductDetails[k].Height;
      obj3.uom = 'inches'; //a.ProductDetails[k].UnitName;
      obj3.hsnno = a.ProductDetails[k].HSNNo;
      obj3.price = a.ProductDetails[k].Price;
      var total = parseFloat(a.ProductDetails[k].Price) * parseFloat(a.ProductDetails[k].Qty);
      if (a.OrderDetails.ConsignerState == a.OrderDetails.ConsigneeState) {
        obj3.SGSTAmount = total * (9 / 100);
        obj3.CGSTAmount = total * (9 / 100);
        obj3.IGSTAmount = 0;
        obj3.GSTTaxRateCGSTN = 9;
        obj3.GSTTaxRateSGSTN = 9;
        obj3.GSTTAXRateIGSTN = 0;
      } else {
        obj3.SGSTAmount = 0;
        obj3.CGSTAmount = 0;
        obj3.IGSTAmount = total * (18 / 100);
        obj3.GSTTaxRateCGSTN = 0;
        obj3.GSTTaxRateSGSTN = 0;
        obj3.GSTTAXRateIGSTN = 18;
      }
      obj3.Discount = 0;
      obj3.GSTTaxTotal = (obj3.SGSTAmount + obj3.CGSTAmount + obj3.IGSTAmount);
      obj3.TaxableValue = total + obj3.GSTTaxTotal;
      data.products.push(obj3);

      var obj4: any = {};

      obj4.reference_number = a.OrderDetails.ReferenceNo; //ASK
      obj4.delivery_number = null; //ASK
      obj4.product_id = "";
      obj4.product_name = 'OTHERS'; //a.ProductDetails[k].ProductName;
      obj4.product_display_name = a.ProductDetails[k].ProductName;
      obj4.units = a.ProductDetails[k].Qty;
      obj4.unit_type = 'Units'; //a.ProductDetails[k].UnitName;
      obj4.weight = a.ProductDetails[k].weight;
      obj4.billable_weight = a.ProductDetails[k].VolumetricWeight > a.OrderDetails.Weight == true ? a.ProductDetails[k].VolumetricWeight : a.OrderDetails.Weight;
      obj4.weight_measure = "Kgs";
      obj4.length = a.ProductDetails[k].Length;
      obj4.width = a.ProductDetails[k].Width;
      obj4.height = a.ProductDetails[k].Height;
      obj4.uom = 'inches'; //a.ProductDetails[k].UnitName;
      obj4.Barcode = a.ProductDetails[k].Barcode;
      obj4.product_code = a.ProductDetails[k].ProductCode;
      obj4.Category = a.ProductDetails[k].Category;
      data.consignment_contents_common.consignment_content_common.push(obj4);
    }

    data.consignment.consignment_invoices = {};
    data.consignment.consignment_invoices.consignment_invoice = [];
    for (let k = 0; k < a.InvoiceDetails.length; k++) {
      var obj: any = {};

      obj.invoice_number = a.InvoiceDetails[k].InvoiceNo;
      obj.delivery_number = null; //ASK
      obj.invoice_value = a.InvoiceDetails[k].Amount;
      obj.invoice_date = a.InvoiceDetails[k].InvoiceDate;
      obj.cod_amount = a.InvoiceDetails[k].Amount;
      obj.weight = a.OrderDetails.Weight;
      obj.billable_weight = a.InvoiceDetails[k].VolumetricWeight > a.OrderDetails.Weight ? a.InvoiceDetails[k].VolumetricWeight : a.OrderDetails.Weight;
      obj.weight_measure = "Kgs";
      obj.pickable_units = a.InvoiceDetails[k].Qty;
      obj.eway_bill_number = a.InvoiceDetails[k].eWayBill;
      obj.eway_bill_expiry_date = a.InvoiceDetails[k].eWayBillExpiryDate;
      data.consignment.consignment_invoices.consignment_invoice.push(obj);
    }

    data.parcellist = [];
    for (let k = 0; k < a.OrdersPackage.length; k++) {
      var obj: any = {};
      obj.weight = a.OrdersPackage[k].GrossWeight;
      obj.length = a.OrdersPackage[k].Length;
      obj.height = a.OrdersPackage[k].Height;
      obj.width = a.OrdersPackage[k].Width;
      obj.item_description = a.OrdersPackage[k].ProductName;
      obj.no_of_items = a.OrdersPackage[k].TotalPackages;
      obj.item_value = a.OrdersPackage[k].InvoiceAmount;
      obj.hscode = a.OrdersPackage[k].HSNNo;
      data.parcellist.push(obj);
    }

    data.consignment.service_provider_id = "";
    data.consignment.service_provider_name = "";
    data.consignment.service_provider_code = "";
    data.consignment.consignment_type = "OUTBOUND-TBB";
    data.OrderId = OrderId;
    data.TransporterId = TransporterId;
    data.PickUpDateTime = a.OrderDetails.PickupDate;
    data.consignor_email = a.OrderDetails.PickUpContactEmail;
    data.consignee_email = a.OrderDetails.DeliveryContactEmail;
    data.consignor_lat = a.OrderDetails.PickUpLatitude;
    data.consignor_long = a.OrderDetails.PickUpLongtitude;
    data.consignee_lat = a.OrderDetails.DeliverLatitude;
    data.consignee_long = a.OrderDetails.DeliverLongtitude;
    data.tax_id = a.OrderDetails.PickupGSTNo;
    data.consignor_country = a.OrderDetails.PickupCountry;
    data.consignee_country = a.OrderDetails.DeliveryCountry;
    data.VolumetricWeight = a.OrderDetails.VolumetricWeight;
    data.PickupDateV2 = a.OrderDetails.PickupDateV2;

    data.Customer = {};
    data.Customer.CustomerAddress1 = a.OrderDetails.CustomerAddress;
    data.Customer.CustomerAddress2 = "";
    data.Customer.CustomerAddress3 = "";
    data.Customer.CustomerEmailID = a.OrderDetails.CustomerMail;
    data.Customer.CustomerGSTNumber = a.OrderDetails.CustomeGST;
    data.Customer.CustomerLatitude = "";
    data.Customer.CustomerLongitude = "";
    data.Customer.CustomerMobile = a.OrderDetails.CustomerMobile;
    data.Customer.CustomerName = a.OrderDetails.CustomerName;
    data.Customer.CustomerPincode = a.OrderDetails.CustomerPincode;
    data.service_code = service_code;

    Helpers.setLoading(true);
    await new Promise(async (resolve1, reject1) => {
      this._appService
        .Post("OrdersByVehicle", "CreateConsignment", data)
        .subscribe(
          async (response) => {
            Helpers.setLoading(false);

            if (response.isScuccess == true) {
              this.toastr.success(
                this.translate.instant("ALERTMESSAGES.ConsignmentSuccess"),
                "Success"
              );

              var ShipmentId, ShipmentNo = '';
              if (TransporterName == "Smart Track") {
                var msg = JSON.parse(response.message);
                ShipmentId = msg['data']['shipment_id'];
                ShipmentNo = msg['data']['shipment_number'];
              }

              Helpers.setLoading(true);
              this._appService
                .GetByEightId(
                  "OrdersByVehicle",
                  "oc_ConfirmCourierData_generateInvoiceOrderWiseV2",
                  OrderId,
                  this.userId,
                  TransporterId,
                  LeadTime,
                  ShipmentId,
                  ShipmentNo,
                  service_code,
                  TotalRate
                )
                .subscribe(
                  async (response) => {
                    Helpers.setLoading(false);
                    if (response[0].isDone == "OK") {
                      this.toastr.success(
                        "Order Confirm successfully !",
                        "Success"
                      );

                      resolve1("Ok");
                      setTimeout(() => {
                        if (this.TransationType == "Air") {
                          window.location.href = '/NewBookingList';
                          // this.router.navigateByUrl(`/NewBookingList`);
                        } else {
                          this.router.navigateByUrl(`/FtlList`);
                        }
                      }, 1000);
                      Helpers.setLoading(false);
                    } else {
                      this.toastr.success(
                        "Error Occurred While ConFirm Booking !",
                        "Error"
                      );
                      Helpers.setLoading(false);
                      resolve1("Ok");
                    }
                    if (response[0].invoiceResult != "Success") {
                      this.toastr.success(
                        "Error Occurred While Generating Shipment !",
                        "Error"
                      );
                      Helpers.setLoading(false);
                      resolve1("Ok");
                    }
                  },
                  (err) => {
                    Helpers.setLoading(false);
                    this.toastr.error(err._body.replace(/"/g, ""), "Error");
                    resolve1("Ok");
                  }
                );
            } else {
              var msg = JSON.parse(response.message);

              if (TransporterName == "V-Xpress")
                this.toastr.error(msg.exception.message, "Error");

              if (
                TransporterName == "Delhivery" ||
                TransporterName == "OM Logistics"
              )
                this.toastr.error(msg.message, "Error");

              if (TransporterName == "XpressBees")
                this.toastr.error(msg.ReturnMessage, "Error");

              if (TransporterName == "Allcargo GATI") {
                // this.toastr.error(msg['meta']['message'], 'Error');
                const detailsArray = msg["meta"]["details"][0];
                if (!detailsArray.includes("{")) {
                  this.toastr.error(detailsArray, "Error", {
                    enableHtml: true,
                  });
                } else {
                  const validJsonString = detailsArray.replace(/'/g, '"');
                  const detailsObject = JSON.parse(validJsonString);
                  let toastrMessage = "";

                  // Loop through details and format message
                  for (const key in detailsObject) {
                    if (detailsObject.hasOwnProperty(key)) {
                      const nestedObject = detailsObject[key];
                      for (const nestedKey in nestedObject) {
                        if (nestedObject.hasOwnProperty(nestedKey)) {
                          const errors = nestedObject[nestedKey];
                          if (Array.isArray(errors)) {
                            // If errors is an array, iterate over each error
                            errors.forEach((error: string) => {
                              toastrMessage += `${nestedKey}: ${error}<br>`;
                            });
                          } else if (typeof errors === "object") {
                            // If errors is an object, assume it has message arrays
                            for (const prop in errors) {
                              if (
                                errors.hasOwnProperty(prop) &&
                                Array.isArray(errors[prop])
                              ) {
                                errors[prop].forEach((error: string) => {
                                  toastrMessage += `${prop}: ${error}<br>`;
                                });
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  // Show toastr message
                  this.toastr.error(toastrMessage, "Error", {
                    enableHtml: true,
                  });
                }
              }

              if (TransporterName == 'Smart Track') {
                this.toastr.error(msg.errors[0], 'Error');
              }

              Helpers.setLoading(false);
            }
            console.log(response);
          },
          (err) => {
            console.log(err);
            // this.toastr.error(err._body.replace(/"/g, ""), "Error");
            Helpers.setLoading(false);
          }
        );
    });
  }

  GetBidDetails() {
    this._appService
      .GetByTwoId(
        "OrdersByVehicle",
        "GetBiddingDetails",
        this.Orderid,
        this.CompanyId
      )
      .subscribe(
        (res) => {
          if (res.Table[0].BidOpen === true) {
            this.isBidClosed = true;
          } else {
            this.isBidClosed = false;
          }
        },
        (error) => {
          console.error("GetBidDetails", error);
        }
      );
  }

  // GetNewOrdersDetailList(){
  //   this._appService.GetById("OrdersByVehicle","GetNewOrdersDetailList",this.Id).subscribe((res)=>{  
  //     this.PackageList=res.Table;
  //     console.log("GetNewOrdersDetailList::",this.PackageList);
  //   },
  //   (error)=>{
  //     console.error(error);
  //   }
  // );
  // }

    initiateCourierList(data: any) {
      
    this.courierListIds = data;
    var obj: any = {};
    obj.OrderId = this.courierListIds;

    this._appService.Post("OrdersByVehicle", "oc_GetCourierDataByIds", obj).subscribe(
    (response) => {
      this.CourierList = response.Table;
      this.CourierPackages = response.Table1;
      this.CourierDimentions = response.Table2;
      this.CourierAdditionalPack = response.Table4;
      this.OrdersPackage = response.Table5;

      var TransportName: any = [];
      this.CourierList.forEach((element) => {
        TransportName.push(element.TransportName);
      });
      this.TransportNames = Array.from(new Set(TransportName)).join(", ");

      this.OrderData.OrderCount = this.courierListIds.length;
      this.OrderData.SumOfQty = 0;
      this.OrderData.SumOfWeight = 0;
      this.OrderData.Volume = 0;
      this.OrderData.SumOFCFT = 0;

      this.CourierDimentions.forEach((element) => {
        this.OrderData.SumOfQty = this.OrderData.SumOfQty + element.Qty;
      });
      this.CourierPackages.forEach((element) => {
        this.OrderData.SumOFCFT = this.OrderData.SumOFCFT + element.CFT;
        this.OrderData.SumOfWeight =
          this.OrderData.SumOfWeight + element.weight;
        this.OrderData.Volume = this.OrderData.Volume + element.Volume;
      });

      if (this.TransationType != 'Air') {
        this.GetCourierRate();
      } else {
        this.OrderData.SumOfQty = 0;
        this.OrderData.SumOfWeight = 0;
        this.OrderData.SumOfDimension = 0;
        this.OrdersPackage.forEach((element) => {
          this.OrderData.SumOfQty = this.OrderData.SumOfQty + element.TotalPackages;
          this.OrderData.SumOfWeight = this.OrderData.SumOfWeight + element.GrossWeight;
          this.OrderData.SumOfDimension = this.OrderData.SumOfDimension + (element.Length + element.Width);
        });
      }

    },
    (err) => {
      this.toastr.error(
        "Error occurred while fetching Courier data !",
        "error"
      );
    });
  }

  // OnSaveAssignVehicle(event) {
  //   console.log('event', event);
  //   var obj: any = {};
  //   obj = event;
  // }


  OnSaveAssignVehicle(event) {
    
    this.IsAssignvehicleSaveDisable = true;
    var obj: any = {};
    obj = event;
    const estimatedDate = new Date(obj.EstimatedDeliveryDate);
    const placementDate = new Date(obj.VehiclePlacementDate);
    if (estimatedDate <= placementDate && estimatedDate != placementDate) {
      this.toastr.error(this.translate.instant("PENDINGARRIVAL.PlacementDateValidation"), "Alert");
      this.IsAssignvehicleSaveDisable = false;
      return;
    }
    // if (obj.EstimatedDeliveryDate <= obj.VehiclePlacementDate && obj.EstimatedDeliveryDate != obj.VehiclePlacementDate) {
    //   this.toastr.error(this.translate.instant("PENDINGARRIVAL.PlacementDateValidation"), "Alert");
    //   this.IsAssignvehicleSaveDisable = false;
    //   return;
    // }
    if (this.ValidateTHCADvanceAmountFlag == true) {
      if (obj.Advance == 0 || obj.Advance == undefined || obj.Advance == null || obj.Advance == "") {
        var message = this.translate.instant("ALERTMESSAGES.AdvanceAmountShoubeGraterThanZero");
        this.toastr.error(message, "Alert");
        this.IsAssignvehicleSaveDisable = false;
        return;
      }
    }

    this.ManualvehicleOrderList = this.CourierList;
    var FinalDestination = this.ManualvehicleOrderList[0].DeliveryLocationCode;
    // this._appService.GetByTwoId("Booking", "GetOrderAddressFromLocationCode", null, FinalDestination).subscribe(async (response) => {
    //   var DestinationLocation = "";
    //   DestinationLocation = response[0].DeliveryAddress;
    //   var DeliveryAddressUnique: any = [];
    //   var OrderInfo: any = [];
    //   var obj1: any = {};
    //   (obj1.origin = this.ManualvehicleOrderList[0].PickupAddress), (obj1.destination = response[0].DeliveryAddress);
    //   OrderInfo.push(obj1);

    //   this.ManualvehicleOrderList.map(function (item) {
    //     if (BiddingComponent.that.ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag == true) {
    //       item.DeliveryAddress = response[0].DeliveryAddress;
    //     }
    //     var existItem = DeliveryAddressUnique.find((x) => x.location == item.DeliveryAddress);
    //     if (!existItem) {
    //       var obj: any = {};
    //       (obj.location = item.DeliveryAddress),
    //         (obj.stopover = true),
    //         (obj.Order = 0),
    //         (obj.RouteOrder = "A");
    //       DeliveryAddressUnique.push(obj);
    //     }
    //   });

    //   var DeliveryAddressUniqueResult: any = [];
    //   BiddingComponent.that.calculateRouteOptimization(OrderInfo, DeliveryAddressUnique).then(async (res) => {
    //     setTimeout(() => {
    //       DeliveryAddressUniqueResult = res;
    //       for (let i = 0; i < this.ManualvehicleOrderList.length; i++) {
    //         for (let j = 0; j < DeliveryAddressUniqueResult.length; j++) {
    //           if (
    //             this.ManualvehicleOrderList[i].DeliveryAddress ==
    //             DeliveryAddressUniqueResult[j].location
    //           ) {
    //             this.ManualvehicleOrderList[i].RouteOrder =
    //               DeliveryAddressUniqueResult[j].RouteOrder;
    //           }
    //         }
    //       }

    //       for (let i = 0; i < this.ManualvehicleOrderList.length; i++) {
    //         this.ManualvehicleOrderDetail[i] = {};
    //         this.ManualvehicleOrderDetail[i].OrderID = this.ManualvehicleOrderList[i].Id;
    //         this.ManualvehicleOrderDetail[i].PickupLocationCode = this.ManualvehicleOrderList[i].PickupLocationCode;
    //         this.ManualvehicleOrderDetail[i].DeliveryLocationCode = FinalDestination;
    //         if (this.isSTPBooking) {
    //           this.ManualvehicleOrderDetail[i].DeliveryLocationCode = this.ManualvehicleOrderList[i].DeliveryLocationCode;
    //         }
    //         this.ManualvehicleOrderDetail[i].Qty = this.ManualvehicleOrderList[i].Qty;
    //         this.ManualvehicleOrderDetail[i].OrderItemsId = this.ManualvehicleOrderList[i].OrderItemsId == undefined ? null : this.ManualvehicleOrderList[i].OrderItemsId;
    //         this.ManualvehicleOrderDetail[i].VehicleOrdersProductID = this.ManualvehicleOrderList[i].VehicleOrdersProductID == undefined ? null : this.ManualvehicleOrderList[i].VehicleOrdersProductID;
    //         this.ManualvehicleOrderDetail[i].RouteOrder = this.ManualvehicleOrderList[i].RouteOrder;
    //       }

    //       this.ManualvehiclePlanning.ManualvehicleOrderDetail = this.ManualvehicleOrderDetail;
    //       this.ManualvehiclePlanning.TransportServiceId = obj.TransportService;
    //       this.ManualvehiclePlanning.TransporterId = obj.Transporter;
    //       this.ManualvehiclePlanning.VehicleTypeID = obj.VehicleType;
    //       this.ManualvehiclePlanning.VehicleNo = obj.VehicleNo;
    //       this.ManualvehiclePlanning.DriverCode = obj.Driver;
    //       this.ManualvehiclePlanning.DriverMobileNo = obj.DriverMobileNo;
    //       this.ManualvehiclePlanning.VehiclePlacementDate = obj.VehiclePlacementDate;
    //       this.ManualvehiclePlanning.EstimatedDeliveryDate = obj.EstimatedDeliveryDate;
    //       this.ManualvehiclePlanning.BookingType = "primary"; //this.BookingType;
    //       this.ManualvehiclePlanning.BookingTypeAuto = null;
    //       this.ManualvehiclePlanning.LeadTime = obj.LeadTime;
    //       this.ManualvehiclePlanning.Advance = obj.Advance;
    //       // if (this.isSTPBooking) {
    //       //   this.ManualvehiclePlanning.BookingTypeAuto = this.STPModelListData[this.STPIdexId].BookingType;
    //       // }
    //       this.ManualvehiclePlanning.CompanyId = this.CompanyId;
    //       this.ManualvehiclePlanning.opa_userId = this.userId;
    //       this.ManualvehiclePlanning.Captain = null;
    //       this.ManualvehiclePlanning.IsFromRouteOptimization = false;
    //       this.ManualvehiclePlanning.RouteOptimization = true;
    //       this.ManualvehiclePlanning.PotterTripId = null;
    //       this.ManualvehiclePlanning.ChargeAmount = obj.BidAmount || 0;
    //       this.ManualvehiclePlanning.IsFromManualPlanning = false;
    //       //added by vithu 07-04-2025
    //       this.ManualvehiclePlanning.IsAutomateRecordIncomeConsignmentWise = false;
    //       // this.ManualvehiclePlanning.IsAutomateTripExpense = true;
    //       this.ManualvehiclePlanning.ShipNowType = 'Bidding';

    //       BiddingComponent.that._appService.Post("ManualvehiclePlanning", "CreateBookingFromManualPlan", BiddingComponent.that.ManualvehiclePlanning).subscribe((response) => {
    //         this.IsAssignvehicleSaveDisable = false;
    //         if (response == true) {
    //           BiddingComponent.that.toastr.success("Booking Created Successfully !", "Success");
    //           BiddingComponent.that.modalRef.close();
    //           if (this.TransationType == 'FTL') {
    //             BiddingComponent.that.router.navigateByUrl(`/FtlList`);
    //           } else if (this.TransationType == 'ContainerMovement') {
    //             BiddingComponent.that.router.navigateByUrl(`/Container-Movement`);
    //           } else {
    //             BiddingComponent.that.router.navigateByUrl(`/FtlList`);
    //           }
    //         }
    //       },
    //         (err) => {
    //           BiddingComponent.that.toastr.error(err._body.replace(/"/g, ""), "Error");
    //           this.IsAssignvehicleSaveDisable = false;
    //         }
    //       );
    //     }, 2000);
    //   });
    // },
    //   (err) => {
    //     this.toastr.error(err._body.replace(/"/g, ""), "error");
    //     this.IsAssignvehicleSaveDisable = false;
    //   }
    // );
  }

  getChangedValue(value, field, row) {

    if (field.dataField == "BidAmount") {
      this.VehicleReqiredId = row.OrdersItemByVehicleId
      this.VehicleTypeId = row.VehicleTypeId
      this.updateSelectedVehicle({
        VehicleAmount: value,
        bidDetailId: row.Id,
        VehicleReqiredId: row.OrdersItemByVehicleId,
        VehicleTypeId: row.VehicleTypeId
      });
    }
    if (field.dataField == "Remark") {
      this.BidTransporter.Remark = value;
      this.VehicleReqiredId = row.OrdersItemByVehicleId
      this.VehicleTypeId = row.VehicleTypeId
      this.updateSelectedVehicle({
        Remark: value,
        bidDetailId: row.Id,
        VehicleReqiredId: row.OrdersItemByVehicleId,
        VehicleTypeId: row.VehicleTypeId
      });
    }
    if (field.dataField == "AvailableDate") {
      this.VehicleReqiredId = row.OrdersItemByVehicleId
      this.VehicleTypeId = row.VehicleTypeId
      this.updateSelectedVehicle({
        AvailableDate: value,
        bidDetailId: row.Id,
        VehicleReqiredId: row.OrdersItemByVehicleId,
        VehicleTypeId: row.VehicleTypeId
      });
    }
    this.calculateTotalBidAmount();
    console.log("BidTransporter:", this.BidTransporter);
  }

  updateSelectedVehicle(
    updatedFields: Partial<{
      bidDetailId: any;
      VehicleReqiredId: any;
      AvailableDate: any;
      VehicleAmount: any;
      Remark: any;
      VehicleTypeId: any,
    }>
  ) {
    const existingVehicle = this.selectedVehicles.find(
      (vehicle) => vehicle.bidDetailId === updatedFields.bidDetailId
    );

    if (existingVehicle) {
      Object.assign(existingVehicle, updatedFields);
      console.log("BidTransporter existingVehicle:", this.selectedVehicles);
    } else {
      //   
      // Add a new entry with default values
      this.selectedVehicles.push({
        bidDetailId: null,
        VehicleReqiredId: null,
        AvailableDate: null,
        VehicleAmount: null,
        Remark: '',
        VehicleTypeId: null,
        ...updatedFields,
      });

      this.calculateTotalBidAmount();

      console.log("BidTransporter Not existingVehicle:", this.selectedVehicles);
    }
  }

  calculateTotalBidAmount(): void {
    this.totalBidAmount = this.selectedVehicles.reduce((total, vehicle) => {
      const amount = parseFloat(vehicle.VehicleAmount);
      return total + (isNaN(amount) ? 0 : amount);
    }, 0);
  }

  calculateTimeRemaining() {
    // added by priya - 28/01/25
    if (!this.biddingduration) {
      // console.log('Bidding duration is not available.');
      return;
    }
    const biddingEndDate = new Date(this.biddingduration);
    // Get the current date and time in UTC
    const currentDate = new Date();
    // Log both dates to check if they are correct
    // console.log('Bidding End Date (UTC):', biddingEndDate.toISOString());
    // console.log('Current Date (UTC):', currentDate.toISOString());
    // Calculate the difference in milliseconds
    const timeDifference = biddingEndDate.getTime() - currentDate.getTime();
    // Log the time difference
    // console.log('Time Difference in Milliseconds:', timeDifference);
    // If the bidding time has passed
    if (timeDifference <= 0) {
      this.biddingendsin = `00days 00h 00m 00s`;
      this.isSubmitDisable = false;
      // console.log('Bidding has ended.');
      if (this.interval) {
        clearInterval(this.interval); // Stop the timer
      }
      return;
    } else {
      this.isSubmitDisable = true;
    }
    // Calculate days, hours, minutes, and seconds for the remaining time
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    // Format the result and display it
    this.biddingendsin = `${days.toString().padStart(2, "0")}days ${hours
      .toString()
      .padStart(2, "0")}h ${minutes.toString().padStart(2, "0")}m ${seconds
        .toString()
        .padStart(2, "0")}s`;

    // console.log('Time remaining:', this.biddingendsin);
  }

  closeBidDetailsModalOpen() {
    this.isBidDetailsModalOpen = false;
  }

  SubmitTransporterBids() {
    this.calculateTotalBidAmount()
    const invalidVehicles = this.selectedVehicles.filter(
      (vehicle) => vehicle.VehicleAmount > this.OrderListDetails.MinBidAmount
    );

    if (invalidVehicles.length > 0) {
      this.toastr.error(
        "Amount should be less than the minimum bid amount",
        "Error"
      );
      console.log("Invalid vehicles:", invalidVehicles);
      return; // Stop submission
    }
    this.BidTransporter.IndentId = this.Orderid;
    this.BidTransporter.TransporterId = this.TransporterId;
    this.BidTransporter.Amount = this.totalBidAmount;
    this.BidTransporter.BiddingDetails = this.selectedVehicles;
    console.log('biddingdetail', this.BidTransporter)

    console.log('selectedVehicles', this.BidTransporter)
    this._appService.Post("OrdersByVehicle", "UpdateNewTransporterBid", this.BidTransporter).subscribe((response) => {
      Helpers.setLoading(false);
      if (response[0].isDone) {
        this.toastr.success("Bid Sumbitted sucessfully !", "Success");
        this.isBidDetailsModalOpen = false;
        this.GetTransporterListHired();
      } else {
        this.toastr.error("Your Bid Submission Failed !", "Error");
      }
    },
      (err) => {
        console.log(err);
        Helpers.setLoading(false);
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      });
  }

    async calculateRouteOptimization(
      OrderInfoData,
      DestinationLocation
    ): Promise<Observable<any>> {
      try {
        if (DestinationLocation.length > 1) {
          const directionsService = new google.maps.DirectionsService();
          const waypts = [];
          for (let i = 0; i < DestinationLocation.length; i++) {
            waypts.push({
              location: DestinationLocation[i].location,
              stopover: true,
            });
          }
          await directionsService.route(
            {
              origin: OrderInfoData[0].origin,
              destination: OrderInfoData[0].destination,
              waypoints: waypts,
              optimizeWaypoints: true,
              travelMode: google.maps.TravelMode.DRIVING,
            },
            (response, status) => {
              if (status === "OK") {
                let ViewPoints = [];
                ViewPoints = response.routes[0].waypoint_order;
                var mainNum = 65;
                var subNum = 63;
                for (let i = 0; i < ViewPoints.length; i++) {
                  DestinationLocation[ViewPoints[i]].Order = i;
                  DestinationLocation[ViewPoints[i]].RouteOrder =
                    subNum == 63
                      ? String.fromCharCode(mainNum)
                      : String.fromCharCode(mainNum) +
                      String.fromCharCode(subNum);
                  if (mainNum == 90 || subNum == 90) {
                    mainNum = subNum == 63 ? 65 : mainNum + 1;
                    subNum = 64;
                  }
                  subNum = subNum == 63 ? subNum : subNum + 1;
                  mainNum = subNum == 63 ? mainNum + 1 : mainNum;
                }
                // this.OrderDestinationLocation1=(DestinationLocation);
                // return this.OrderDestinationLocation1;
              } else {
                // window.alert("Directions request failed due to " + status);
              }
            }
          );
        }
      } catch (error) {
        return DestinationLocation;
      }
      return DestinationLocation;
    }


     async GetCourierRate() {
    const hasComma = this.courierListIds.includes(",");

    var obj: any = [];
    if (hasComma == false) {
      obj.push(this.courierListIds);
    } else {
      obj = this.courierListIds.split(",").map((item) => item.trim());
    }

    for (let i = 0; i < obj.length; i++) {
      await new Promise(async (resolve1, reject1) => {
        this._appService
          .GetByTwoId(
            "OrdersByVehicle",
            "oc_GetCourierRate",
            obj[i],
            this.CompanyId
          )
          .subscribe(
            (response) => {
              this.CourierRate = [];
              this.CourierRate = response;
              var SubTotal = 0;
              var totalSGST = 0;
              var totalCGST = 0;
              var totalIGST = 0;
              this.NetTotal = 0;
              this.CourierRate.forEach((element) => {
                SubTotal = SubTotal + element.ChargeRate;
                totalSGST =
                  totalSGST + element.ChargeRate * (element.SGST / 100);
                totalCGST =
                  totalCGST + element.ChargeRate * (element.CGST / 100);
                totalIGST =
                  totalIGST + element.ChargeRate * (element.IGST / 100);
              });
              SubTotal = parseFloat(SubTotal.toFixed(2));
              totalSGST = parseFloat(totalSGST.toFixed(2));
              totalCGST = parseFloat(totalCGST.toFixed(2));
              totalIGST = parseFloat(totalIGST.toFixed(2));

              if (this.TaxApplicableFlag == false) {
                this.NetTotal = parseFloat(SubTotal.toFixed(2));
                totalSGST = 0;
                totalCGST = 0;
                totalIGST = 0;
              } else {
                this.NetTotal = parseFloat(
                  (SubTotal + totalSGST + totalCGST + totalIGST).toFixed(2)
                );
              }
              resolve1("OK");
            },
            (err) => {
              this.toastr.error(
                "Error occurred while fetching courier rate data !",
                "error"
              );
              resolve1("OK");
            }
          );
      });
    }
  }

  handleOption(event: { category, value ,data}) {
    if(event.category.trim() === 'Send Bid Request'){
      if(event.value.trim() === 'Via Mail'){
          this.SaveTransportersBids(event.data, "Mail");
      }
      if (event.value.trim() === 'Via WhatsApp') {
        this.SaveTransportersBids(event.data, "WhatsApp");
      }
    } else if(event.category.trim() === 'Send Vehicle Request'){
       if(event.value.trim() === 'Via Mail'){
          this.SendVehicleRequest(event.data, "Mail");
       }
      if (event.value.trim() === 'Via WhatsApp') {
        this.SendVehicleRequest(event.data, "WhatsApp");
      }
    } else if(event.category.trim() === 'Set Bid Amount'){
      if(event.data){
        let row = event.data;
        this.TransporterId = row.Id;
        let transporterList = []
        const transformVehicleTypes = (vehicleType, vehicleTypeId) => {
          const vehicleTypeArray = vehicleType.split(", "); // Split VehicleType string
          const vehicleTypeIdArray = vehicleTypeId.split(", "); // Split VehicleTypeId string

          // Map them into an array of objects
          return vehicleTypeArray.reduce((result, type, index) => {
            const [vehicle, quantity] = type.split(" X "); // Split into VehicleType and Quantity
            const qty = parseInt(quantity) || 1; // Default to 1 if Quantity is not present

            // Expand the vehicle type based on quantity
            for (let i = 0; i < qty; i++) {
              result.push({
                VehicleType: vehicle.trim(),
                VehicleTypeId: vehicleTypeIdArray[index].trim(), // Match VehicleTypeId
              });
            }
            return result;
          }, []);
        };

      transporterList = Array.isArray(row)
        ? row.reduce((acc, element) => {
          const vehicleData = transformVehicleTypes(element.VehicleType, element.VehicleTypeId);
          const expandedData = vehicleData.map((data) => ({
            ...element,
            IsEmailSms: 'self',
            TransporterId: element.Id,
            Transporter: element.Name,
            IndentId: this.Orderid,
            IndentNo: this.IndentNo,
            UserId: this.UserId,
            IsContracted: false,
            VehicleType: data.VehicleType,
            VehicleTypeId: data.VehicleTypeId,
          }));
          return acc.concat(expandedData);
        }, [])
        : transformVehicleTypes(row.VehicleType, row.VehicleTypeId).map((data) => ({
          ...row,
          IsEmailSms: 'self',
          TransporterId: row.Id,
          Transporter: row.Name,
          IndentId: this.Orderid,
          IndentNo: this.IndentNo,
          UserId: this.UserId,
          IsContracted: false,
          VehicleType: data.VehicleType,
          VehicleTypeId: data.VehicleTypeId,
        }));

        this._appService.Post("OrdersByVehicle", "SaveManualBidDetails", transporterList).subscribe((response) => {
          Helpers.setLoading(false);
          if (response[0].isDone) {
            this.fetchBidDetails(row.Id);
          } else {
            this.toastr.error("Bid Load failed !", "Error");
          }
        },
          (err) => {
            console.log(err);
            Helpers.setLoading(false);
            this.toastr.error(err._body.replace(/"/g, ""), "Error");
          });
        console.log('transporterlist', transporterList)
      }
    } else if(event.category.trim() == 'Award Shipment'){ //added by fahim 02-02-2026 :)
      let row = event.data;
      console.log(`${row.Name} Won the aword`);
      this.UpdateAwardShipment(row.trnasporterBidDetailId,row.Name);
    }
  }

  GetBiddingChargeList(IndentId,TransporterId,VehicleTypeId) {
  Helpers.setLoading(true)
    this._appService.GetById('OrdersByVehicle', 'GetBiddingChargeList',IndentId).subscribe(
      (response) => {
        if (response && response.length > 0) {

          const chargeBreakup = response.map(x => ({
            ...x,
            Qty:1,
            OrderId:IndentId,
            TransporterId,
            VehicleTypeId
          }));

          this.checkShipNowChargeBreakupData(
            IndentId,
            TransporterId,
            VehicleTypeId,
            chargeBreakup
          );

          console.log('chargeBreakup',chargeBreakup);
        }
        Helpers.setLoading(false)
      },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
        Helpers.setLoading(false)
      }
    );
  }  

  checkShipNowChargeBreakupData(IndentId, TransporterId, VehicleTypeId,chargeBreakup,) {
   const Payload = {
    IndentId,
    TransporterId,
    isBidding: true,
    VehicleTypeId
  };

  this._appService
    .Post(
      'OrdersByVehicle',
      'CheackShipNowChargeBreakupData',
      Payload
    )
    .subscribe(
      (response) => {
        if ( 
          response &&
          response.length > 0 &&
          response[0] &&
          response[0].Result === 'No'
        ) {
          this.saveShipNowChargeBreakup(chargeBreakup);
        }

        console.log('checkShipNowChargeBreakupData',response);
      },
      (error) => {
        console.error('Error while checking charge breakup data');
      }
    );
  }

  saveShipNowChargeBreakup(chargeBreakup) {
  const obj = {
    CreatedBy: this.UserId,
    ShipNowChargeBreakup_Table: chargeBreakup,
    isBidding: true
  };
  this._appService
    .Post('OrdersByVehicle', 'SaveShipNowChargeBreakup', obj)
    .subscribe(
      (response) => {
        console.log('SaveShipNowChargeBreakup Success');
      },
      (error) => {
        console.error('Error while saving SaveShipNowChargeBreakup');
      }
    );
  }

  UpdateAwardShipment(Id,Transporter){ //added by fahim 02-02-2026 :)
    this._appService.GetByOneParam('OrdersByVehicle','UpdateAwardShipment',Id).subscribe(
      (response)=>{
        this.toastr.success(`The shipment has been successfully awarded to ${Transporter}`,'Success');
      },
      (error)=>{
        console.error('Error while updating award shipment');
      }
    );
  }
  
  isSearchPopupOpen = false;

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'f') {
      event.preventDefault(); 
      this.isSearchPopupOpen = true;
      this.searchfocus();
    }
  }

  searchfocus(){
    setTimeout(() => {
      $("#" + this.searchFieldDetails.formControlName).focus();
    }, 100);
  }
  
  closeSearchPopup() {
    this.isSearchPopupOpen = false;
  }

  onSearch(value: any) {
    this.searchValue = value
    this.GetTransporterListHired();
  }
  
  BiddingTransporterId:any;
  BiddingIndentId:any;
  SelectedVehicleTypeId:any;
  isBidding:any;
  IsContracted:any;
  TransportersBidsId:any;
  TransportersBidsDetailsId:any;
  selectedFilter:any;

  NewButtonHandle(event:any){
    console.log('NewButtonHandle in BiddingComponent event',event.event);
    console.log('NewButtonHandle in BiddingComponent data',event.data);
    this.BiddingTransporterId=event.data.Id;
    this.BiddingIndentId=this.Orderid;
    this.SelectedVehicleTypeId=event.data.VehicleTypeId;
    this.totalBidAmount=event.data.MinBidAmount;
    this.TransportersBidsId=event.data.TransportersBidsId;
    this.TransportersBidsDetailsId=event.data.trnasporterBidDetailId;
    this.AvailableDate = (event.data.AvailabilityDate !== null && event.data.AvailabilityDate !== undefined && event.data.AvailabilityDate !== '') ? event.data.AvailabilityDate : this.dp.transform(new Date(), 'dd MMM yyyy HH:mm');
    this.isBidding = true;
    this.IsContracted=false;
    this.selectedFilter = (event.data.BidStatus === 'Sent' && (event.data.isBooking === false || event.data.isBooking === 'false')) ? 'Active' : '';
    this.modalRef = this.modalService.open(this.ContractedRateBreak, {size:"lg",centered: true});
  }

  onRefreshList(event:any){
    if(event === 'true'){
      this.GetTransporterListHired();      
    }
  }
}
